<template>
  <div>
    <div class="columns m-t-none m-b-none is-vcentered">
      <div class="column">
        <div class="content has-text-centered">
          <h2>
            Frequently Asked Questions
          </h2>
        </div>
      </div>
      <!-- <div class="column">
        <form
          action=""
          @submit.prevent="filterData"
        >
          <search
            v-model="searchObj"
            :attrs="{ input: { placeholder: 'Search in FAQ' }}"
            class="m-none is-pulled-right"
            @clear="filterData"
            @search="filterData"
          />
        </form>
      </div> -->
    </div>
    <div
      v-for="(faq, index) in faqs"
      :key="index"
      :class="{ 'm-none p-none is-borderless': index === 0 }"
      class="faq content"
    >
      <h3 v-text="faq.title" />
      <div
        v-for="(text, index2) in faq.content"
        :id="(text.anchor) ? text.anchor : `faq-${index2}`"
        :key="index2"
        class="content"
      >
        <h4 v-text="text.title" />
        <div v-html="text.content" />
      </div>
    </div>

    <div class="content m-t-xl">
      <p>
        If you couldn't find an answer to your questions here, please <router-link :to="{ name: 'contact-us' }">
          contact us
        </router-link>.
      </p>
    </div>
  </div>
</template>

<script>
// import { mapValues, isString } from 'lodash';
// import Search from '@/components/common/Search';
var VueScrollTo = require('vue-scrollto');

if (location.hash) {
  setTimeout(function() {

    window.scrollTo(0, 0);
  }, 1);
}

export default {
  name: 'FAQComponent',
  components: {
    // Search,
  },
  props: {
    faqs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchObj: {
        search: '',
        type: null,
      },
      filteredData: [],
    };
  },
  beforeMount() {
    // this.filterData();
  },
  mounted() {
    this.$nextTick(() => {
      if (window.location.hash) {
        this.goTo(String(window.location.hash).replace('#', ''));
      }
    });
  },
  methods: {
    goTo(to) {
      VueScrollTo.scrollTo(document.getElementById(to));
    },
    // filterData() {
    //   if (!this.searchObj.search) {
    //     this.filteredData = this.faqs;
    //   } else {
    //     let string = this.searchObj.search;
    //     string = string.toLowerCase();
    //     this.filteredData = this.faqs.filter((row) => {
    //       let values = Object.values(mapValues(row, (s) => {
    //         return isString(s) ? s.toLowerCase() : (s instanceof dayjs) ? s.format(this.options.dateFormat).toLowerCase() : s; // eslint-disable-line
    //       }));
    //       return values.find(el => {
    //         if (el && el.indexOf) {
    //           return el.indexOf(string) > -1;
    //         }
    //         return false;
    //       });
    //     });
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
  .faq {
    margin-top: 2rem;
    padding-top: 2rem;
    border-top: 1px solid $ghost-gray;

    h4 {
      margin-bottom: 0;
    }
  }
</style>